import { mapContentModules } from '../contentModuleMapper';
import { mapPageSections } from '../pageSectionMapper';
import { mapTags } from '../PageSettings/tagsMapper';
import { mapPageSettings } from '../pageSettingsMapper';
import logger from '3-foundation/Logging/logger';

export const mapBasePageProperties = async (properties: Umbraco.BasePage, siteId?: string, locale?: string): Promise<Content.BasePage> => {
	try {
		return {
			title: properties.title || null,
			description: properties.description || null,
			noIndex: properties.noIndex || null,
			noFollow: properties.noFollow || null,
			pageHeader: await mapContentModules(properties.pageHeader?.items ?? [], siteId, locale),
			pageSections: await mapPageSections(properties.pageSections?.items ?? [], siteId, locale),
			pageSettings: mapPageSettings(properties.pageSettings?.items ?? []),
			pageBackgroundColor: properties.pageBackgroundColor === 'Body Background Contrast' ? 'bodyBackgroundContrast' : 'bodyBackground',
			tags: mapTags(properties.tags),
		};
	} catch (e) {
		logger.error(`Could not map BasePage Properties \nCause: ${e}`);
		throw new Error(`Could not map BasePage Properties \nCause: ${e}`, e);
	}
};
